import React from "react";

const HeroPortfolio = () => {
	return (
		<header className="hero-portfolio" id="home">
			<div className="hero-portfolio__content ">
				<h1>
					Raúl Camacho M.
					<span>Software Engineer | Web Developer</span>
				</h1>
				<div className=" hero-portfolio__social-media">
					<ul>
						<li className="github">
							<span>Github</span>
							<a href="https://github.com/Raulcmm/" target="_blank" rel="noreferrer">
								<i className="fab fa-github" />
							</a>
						</li>
						<li className="linkedin">
							<span>LinkedIn</span>
							<a href="https://www.linkedin.com/in/raul-camacho-rcm/" target="_blank" rel="noreferrer">
								<i className="fab fa-linkedin-in"></i>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</header>
	);
};

export default HeroPortfolio;
